import { createContext, useContext } from "react";
import { useAuth } from "./AuthProvider";

const PermissionContext = createContext();

export const PermissionProvider = ({ children }) => {
  const { groups, loading } = useAuth();

  const hasRole = (roleGroupId) => groups.includes(roleGroupId);

  return (
    <PermissionContext.Provider value={{ hasRole, loading }}>
      {children}
    </PermissionContext.Provider>
  );
};

export const usePermission = () => useContext(PermissionContext);
